<template>
  <div class="container">
    <PublicHeader />
    <!-- 添加提币地址 -->
    <div class="title">{{ $t('safe').Addwithdrawaladdress }}</div>
    <!-- 选择币种 -->
    <div class="tit">{{ $t('safe').Withdrawalcurrency }}</div>
    <div class="selInfo" @click="showcurrency = true">
      <div class="left">
        <img class="img" :src="require(`@/assets/img/${currency}.png`)" />
        <div class="name">{{ currency }}</div>
      </div>
      <van-icon name="play" size="13" class="ric" color="var(--text_color)" />
    </div>
    <PopupSelect :title="$t('safe').Withdrawalcurrency" v-model="showcurrency" :selectList="currencyArr"
      :selectedValue="currency" :onSelect="onSelectCurrency" />
    <!-- 选择网络 -->
    <div class="tit">{{ $t('recharge').network }}</div>
    <div class="networkInfo" @click="shownetwork = true">{{ network }}
      <span> <van-icon name="play" size="13" class="ric" color="var(--text_color)" /> </span>
    </div>
    <PopupSelect :title="$t('recharge').network" v-model="shownetwork" :selectList="networkArr" :selectedValue="network"
      :onSelect="onSelectNetwork" />
    <!-- 提币地址 -->
    <div class="tit">{{ $t('safe').Withdrawaladdress }}</div>
    <van-field v-model="address" :placeholder="$t('safe').WithdrawaladdressTips">
    </van-field>
    <!-- 备注 -->
    <div class="tit">{{ $t('safe').remark }}</div>
    <van-field v-model="remark" placeholder="">
    </van-field>
    <!-- 按钮 -->
    <van-button block :loading="btnloading" @click="handleSub">{{ $t('safe').confirm }}</van-button>
  </div>
</template>

<script>
import userApi from '@/api/user'
import systemApi from '@/api/system'
import PublicHeader from '@/components/publicHeader'
import PopupSelect from '@/components/popupSelect.vue'
import { EventBus } from '@/utils/event-bus'

export default {
  components: {
    PublicHeader,
    PopupSelect,
  },
  data() {
    return {
      btnloading: false,
      showcurrency: false,
      currency: 'USDT',
      currencyArr: [],
      shownetwork: false,
      network: '',
      networkArr: [],
      allnetworkArr: [],
      currencyNetwork: [],
      address: '',
      remark: '',
      addressList: [],
    }
  },
  mounted() {
    EventBus.$on('btnloading', () => {
      this.btnloading = false
    })
    this.getWalletAddressList()
  },
  methods: {
    //系统钱包地址
    async getWalletAddressList() {
      const res = await systemApi.getWalletAddressList()
      this.addressList = res.walletAddress
      this.currencyArr = Array.from(new Map(this.addressList.map(item => [item.currency, { text: item.currency, val: item.currency }])).values());
      this.currency = this.currencyArr[0].val
      this.OnNetwork()
    },
    //网络赋值
    OnNetwork() {
      this.networkArr = Array.from(new Map(this.addressList.filter(item => item.currency === this.currency).map(item => [item.network, { text: item.network, val: item.network }])).values())
      this.network = this.networkArr[0].val
    },
    //选择币种
    async onSelectCurrency(action) {
      this.currency = action.text
      this.showcurrency = false
      this.OnNetwork()
    },
    //选择网络
    async onSelectNetwork(val) {
      this.network = val.text
      this.shownetwork = false
    },
    // 提交
    async handleSub() {
      if (!this.checkForm()) return
      const form = {
        currency: this.currency,
        address: this.address,
        network: this.network,
        remark: this.remark,
      }
      this.btnloading = true
      await userApi.addWalletAddress(form)
      this.btnloading = false
      this.$toast(this.$t('safe').Addedsuccessfully)
      this.$router.go(-1)
    },
    checkForm() {
      if (!this.currency) {
        this.$toast(this.$t('safe').Pleaseselectcurrency)
        return false
      }
      if (!this.address) {
        this.$toast(this.$t('safe').WithdrawaladdressTips)
        return false
      }
      if (this.network == 'ETH(Ethereum)') {
        if (this.address.length != 42) {
          this.$toast(this.$t('safe').WithdrawaladdressError)
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 50px 15px 0 15px;
  background: var(--background_color);


  .title {
    margin: 10px 0 30px 0;
    font-size: 25px;
    font-weight: bold;
    color: var(--text_color);
  }


  .tit {
    margin: 20px 0 10px 0;
    font-size: 13px;
    color: var(--text_color);
  }

  .ric {
    transform: rotate(90deg);
  }

  .selInfo {
    margin: 10px 0 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid var(--info_color);
    border-radius: 10px;
    height: 40px;
    padding: 15px;

    .left {
      display: flex;
      align-items: center;

      .img {
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }

      .name {
        margin-left: 10px;
        font-size: 14px;
        font-weight: bold;
        color: var(--text_color);
      }
    }
  }

  .networkInfo {
    margin: 10px 0 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid var(--info_color);
    border-radius: 10px;
    padding: 12px 15px;
    font-size: 16px;
    font-weight: bold;
    color: var(--text_color);
  }

}

.itemss {
  padding: 15px;
  font-size: 14px;
  color: var(--text_color);

  &:active {
    background: var(--background_color);
  }
}


.vue-country-popover-container {
  width: 100%;
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--ntext_color);
  font-size: 14px;
  opacity: 0.9;
}

::v-deep .van-cell {
  background: var(--background_color);
  padding: 0 10px;
  height: 40px;
  border-radius: 10px;
  font-size: 14px;
  border: 1px solid var(--info_color);
}

::v-deep .van-button {
  margin-top: 30px;
  background: var(--text_color);
  height: 40px;
  border-radius: 20px;
  border: 0;
  font-size: 15px;
  color: var(--background_color);
}
</style>
